import { http } from '@/utils/api'
import { withPbx } from '@/stores/network/api'
import * as Sentry from '@/core/sentry'
import { isWhitelistError } from '@/utils/api/whitelist'

export async function loadBackups() {
  try {
    const url = withPbx('backups')

    const { data } = await http.get(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function createBackup() {
  try {
    const url = withPbx(`backups`)

    const { data } = await http.post(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}

export async function restoreBackup(id: string) {
  try {
    const url = withPbx(`backups/${id}/restore`)

    const { data } = await http.post(url)

    return {
      status: 'success' as const,
      payload: data,
    }
  } catch (error) {
    if (!isWhitelistError(error)) {
      Sentry.captureException(error)
    }

    return {
      status: 'error' as const,
      payload: error,
    }
  }
}
